export default "__VITE_ASSET__BHdfiPSj__"